'use client'

const SCROLL_PADDING = 16

function getStickyOffset(): number {
    const bar = document.querySelector<HTMLElement>('[id="sticky-search-bar"]')
    if (!bar || bar.getBoundingClientRect().bottom <= 0) {
        return 0
    }
    return bar.getBoundingClientRect().bottom + SCROLL_PADDING
}

interface SmoothScrollLinkProps {
    href: string
    className?: string
    children: React.ReactNode
}

export function SmoothScrollLink({ href, className, children }: SmoothScrollLinkProps) {
    return (
        <a
            className={className}
            href={href}
            onClick={(e) => {
                e.preventDefault()
                const id = href.replace(/^#/, '')
                const el = document.getElementById(id)
                if (el) {
                    const top = el.getBoundingClientRect().top + window.scrollY - getStickyOffset()
                    window.scrollTo({ top, behavior: 'smooth' })
                }
                window.history.pushState(null, '', href)
            }}
        >
            {children}
        </a>
    )
}
